// Doctor B Theme - Global JavaScript
// Handles navigation, mobile menu, video lazy loading, and interactive elements

class DoctorBTheme {
    constructor() {
        this.init();
    }

    init() {
        this.initMobileMenu();
        this.initActiveNav();
        this.initLazyVideos();
        this.initAllVideosAutoplay();
        this.initSmoothScroll();
        this.initFAQ();
    }

    // Mobile hamburger menu
    initMobileMenu() {
        const hamburger = document.querySelector('.hamburger-btn');
        const mobileMenu = document.querySelector('.mobile-menu-overlay');
        const closeBtn = document.querySelector('.mobile-close-btn');
        const mobileLinks = document.querySelectorAll('.mobile-nav-link');

        if (!hamburger || !mobileMenu) return;

        hamburger.addEventListener('click', () => {
            hamburger.classList.toggle('active');
            mobileMenu.classList.toggle('active');
            document.body.style.overflow = mobileMenu.classList.contains('active') ? 'hidden' : '';
        });

        if (closeBtn) {
            closeBtn.addEventListener('click', () => {
                hamburger.classList.remove('active');
                mobileMenu.classList.remove('active');
                document.body.style.overflow = '';
            });
        }

        mobileLinks.forEach(link => {
            link.addEventListener('click', () => {
                hamburger.classList.remove('active');
                mobileMenu.classList.remove('active');
                document.body.style.overflow = '';
            });
        });
    }

    // Active navigation on scroll
    initActiveNav() {
        const sections = document.querySelectorAll('section[id]');
        const navLinks = document.querySelectorAll('.nav-link, .mobile-nav-link');

        if (sections.length === 0) return;

        window.addEventListener('scroll', () => {
            let current = '';
            sections.forEach(section => {
                const sectionTop = section.offsetTop;
                const sectionHeight = section.clientHeight;
                if (window.pageYOffset >= sectionTop - 100) {
                    current = section.getAttribute('id');
                }
            });

            navLinks.forEach(link => {
                link.classList.remove('active');
                if (link.getAttribute('href') === `#${current}`) {
                    link.classList.add('active');
                }
            });
        });
    }

    // Lazy load videos when in viewport
    initLazyVideos() {
        const lazyVideos = document.querySelectorAll('video.lazy');

        if ('IntersectionObserver' in window) {
            const videoObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const video = entry.target;
                        const source = video.querySelector('source[data-src]');
                        if (source) {
                            source.src = source.dataset.src;
                            source.removeAttribute('data-src');
                            video.load();
                            video.play().catch(() => { });
                        }
                        video.classList.remove('lazy');
                        videoObserver.unobserve(video);
                    }
                });
            }, { threshold: 0.5 });

            lazyVideos.forEach(video => videoObserver.observe(video));
        } else {
            // Fallback for older browsers
            lazyVideos.forEach(video => {
                const source = video.querySelector('source[data-src]');
                if (source) {
                    source.src = source.dataset.src;
                    source.removeAttribute('data-src');
                    video.load();
                }
                video.classList.remove('lazy');
            });
        }
    }

    // Universal video autoplay - All videos play/pause based on visibility
    initAllVideosAutoplay() {
        const allVideos = document.querySelectorAll('video');

        if (allVideos.length > 0 && 'IntersectionObserver' in window) {
            const videoObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    const video = entry.target;
                    if (entry.isIntersecting) {
                        // Play when 50% visible
                        video.play().catch(e => console.log('Autoplay prevented:', e));
                    } else {
                        // Pause when out of view
                        video.pause();
                    }
                });
            }, {
                threshold: 0.5, // Play when 50% of video is visible
                rootMargin: '-50px' // Start pausing 50px before leaving viewport
            });

            allVideos.forEach(video => videoObserver.observe(video));
            console.log(`Auto-observing ${allVideos.length} videos for lazy playback`);
        }
    }

    // Smooth scroll to anchor
    initSmoothScroll() {
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                const href = this.getAttribute('href');
                if (href === '#') return;

                const target = document.querySelector(href);
                if (target) {
                    e.preventDefault();
                    const offsetTop = target.offsetTop - 80;
                    window.scrollTo({
                        top: offsetTop,
                        behavior: 'smooth'
                    });
                }
            });
        });
    }

    // FAQ accordion
    initFAQ() {
        const faqItems = document.querySelectorAll('.faq-item');

        faqItems.forEach(item => {
            const question = item.querySelector('.faq-q');
            if (question) {
                question.addEventListener('click', () => {
                    const wasActive = item.classList.contains('active');

                    // Close all other FAQs
                    faqItems.forEach(otherItem => {
                        if (otherItem !== item) {
                            otherItem.classList.remove('active');
                        }
                    });

                    // Toggle current FAQ
                    if (wasActive) {
                        item.classList.remove('active');
                    } else {
                        item.classList.add('active');
                    }
                });
            }
        });
    }
}

// Shopify cart functions
window.addToCart = function (formData) {
    return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
    })
        .then(response => response.json())
        .then(data => {
            // Update cart count
            return fetch('/cart.js')
                .then(res => res.json())
                .then(cart => {
                    const cartCount = document.querySelector('.cart-count');
                    if (cartCount) {
                        cartCount.textContent = cart.item_count;
                    }
                    return data;
                });
        });
};

// Scroll to offer section
window.scrollToOffer = function () {
    const offerSection = document.querySelector('#order, .product-order');
    if (offerSection) {
        const offsetTop = offerSection.offsetTop - 80;
        window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
        });
    }
};

// Initialize on DOM ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        new DoctorBTheme();
    });
} else {
    new DoctorBTheme();
}
